export const colorKeys = [
  'pending',
  'referred',
  'processing',
  'declined',
  'waitListed',
  'enrolled',
  'started',
  'exited'
] as const
export type ColorKey = typeof colorKeys[number]

export const colors: Record<ColorKey, { fill: string, textColor: string, text: string, toolTip: string, lighter: string, darker: string }> = {
  pending: {
    fill: '#E3D7F2',
    lighter: '#f8f2ff',
    darker: '#cbb8e2',
    textColor: '#2C2C2C',
    text: 'Pending Release',
    toolTip: 'This status indicates that the enrollment been created but has not been sent to the provider. The number next to this status indicates the ranking of this enrollment. Only the items with the top rank can be released.'
  },
  referred: {
    fill: '#CFE6E4',
    lighter: '#f1e6fd',
    darker: '#aed4d1',
    textColor: '#2C2C2C',
    text: 'Referred',
    toolTip: 'This status indicates that the enrollment has been sent to the assigned provider to review and determine if they will accept the child as a student.'
  },
  processing: {
    fill: '#4DA4A4',
    lighter: '#6bcaca',
    darker: '#348888',
    textColor: '#ffffff',
    text: 'Processing',
    toolTip: 'This status indicates that the enrollment has been selected by the assigned provider to attempt to enroll the child as a student.'
  },
  declined: {
    fill: '#BC3656',
    lighter: '#dd5172',
    darker: '#a32542',
    textColor: '#ffffff',
    text: 'Declined',
    toolTip: 'This status indicates that the enrollment has not been selected by the assigned provider.'
  },
  waitListed: {
    fill: '#FCD9AF',
    lighter: '#fae1c3',
    darker: '#ffcf95',
    textColor: '#0c0b0b',
    text: 'Wait-listed',
    toolTip: 'This status indicates that the service provider intends to enroll this child but currently has no room in any of their sessions.'
  },
  enrolled: {
    fill: '#7136BC',
    lighter: '#8042d1',
    darker: '#5e26a7',
    textColor: '#ffffff',
    text: 'Enrolled',
    toolTip: 'This status indicates that the student has been enrolled in the assigned service provider\'s ServicesList.'
  },
  started: {
    fill: '#722A82',
    lighter: '#863897',
    darker: '#601f6e',
    textColor: '#ffffff',
    text: 'Started',
    toolTip: 'This status indicates that the student has started attending the enrolled service.'
  },
  exited: {
    fill: '#5B5A5C',
    lighter: '#838285',
    darker: '#4c4c4d',
    textColor: '#ffffff',
    text: 'Exited',
    toolTip: 'The student has enrolled and subsequently exited the assigned service provider\'s services.'
  }
}
